<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/L9ZWZ3/tc-custom/9780062045300.jpg?1726519260587" alt="This image is the cover for the book Passive Aggressive Notes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Passive Aggressive Notes
      </h1>
      <p class="bookDescription body article font2">
        <p>Part voyeuristic entertainment, part group therapy, <i>Passive Aggressive Notes</i> offers a fascinating look at the all-too-familiar frustrations of embattled office drones, apartment dwellers, parents, and pet owners everywhere. </p><p>This curated collection combines dozens of outrageous, never-before-seen notes as well as favorites from Passiveaggressivenotes.coma 2008 Webby Award Winner and the official "Best Blog" of the South by Southwest Interactive festival. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kerry Miller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Collins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?741b2e1e